import React from 'react'

import { AppRoutes, LayoutType, type RouteConfig } from '../routes.types'

// HR-specific components
const LazyHRKudos = React.lazy(() => import('../../pages/hr/Kudos').then((module) => ({ default: module.KudosPage })))
const LazyHRPeople = React.lazy(() =>
    import('../../pages/hr/People').then((module) => ({ default: module.PeoplePage })),
)

// HRIS Upload components (renamed from hr-uploads)
const LazyHRISDataManagementPage = React.lazy(() =>
    import('../../pages/hr/Uploads/upload').then((module) => ({ default: module.DataManagementPage })),
)

// Shared components for HR
const LazyPeopleDetailPage = React.lazy(() =>
    import('../../pages/shared/PeopleDetailPage').then((module) => ({ default: module.PeopleDetailPage })),
)

export const hrRoutes: RouteConfig[] = [
    // HR-specific routes
    {
        path: AppRoutes.PEOPLE,
        component: LazyHRPeople,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'People',
        description: 'Manage all employees and organizational structure',
        requiredPermission: {
            action: 'view.all', // CASL permission check only - backend determines access
            subject: 'Employee',
        },
    },
    {
        path: AppRoutes.PEOPLE_DETAIL,
        component: LazyPeopleDetailPage,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Employee Profile',
        description: 'View detailed employee profile information',
        requiredPermission: {
            action: 'view.all', // CASL permission check only - backend determines access
            subject: 'Employee',
        },
    },

    // HRIS Upload routes (unified structure)
    {
        path: AppRoutes.UPLOAD_HRIS,
        component: LazyHRISDataManagementPage,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'HRIS Upload',
        description: 'Upload and manage HRIS data and files',
        requiredPermission: {
            action: 'upload', // CASL permission check only - backend determines access
            subject: 'Hris_import',
        },
    },

    // Additional HR routes that are also accessible by managers (shared)
    {
        path: AppRoutes.KUDOS,
        component: LazyHRKudos,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Kudos',
        description: 'Team recognition and kudos',
        requiredPermission: {
            action: 'view', // CASL permission check only - backend determines access
            subject: 'Kudos',
        },
    },
]
